<template>
    <v-container>
        <h1>Planning général</h1>
        <v-btn
            class="mb-3 mr-3"
            color="secondary"
            @click="generatePDF()"
        >
            <v-icon left>  
            mdi-file-pdf-box
            </v-icon>
            Télécharger en PDF
        </v-btn>
        <v-card >
            <v-card-title>
                Filtres
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col
                    cols="12"
                    md="2"
                    >
                        <v-menu
                            ref="menuBegin"
                            :close-on-content-click="false"
                            :return-value.sync="filters.begindate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                :value="momentFormattedBegin"
                                clearable
                                prepend-icon="mdi-calendar"
                                label="Date de début"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                @click:clear="filters.begindate = null; datealert = null;"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="filters.begindate"
                                no-title
                                scrollable
                                locale="fr"
                                @change="onDateChange"
                            >
                            <v-spacer></v-spacer>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col
                    cols="12"
                    md="2"
                    >
                        <v-menu
                            ref="menuEnd"
                            :close-on-content-click="false"
                            :return-value.sync="filters.enddate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                :value="momentFormattedEnd"
                                clearable
                                label="Date de fin"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                @click:clear="filters.enddate = null; datealert = null;"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="filters.enddate"
                                no-title
                                scrollable
                                locale="fr"
                                @change="onDateChange"
                            >
                            <v-spacer></v-spacer>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col
                    cols="12"
                    md="2"
                    >
                        <v-combobox 
                            label="Site"
                            :items="sites" 
                            clearable
                            item-value="id" 
                            item-text="nom" 
                            v-model="siteCmb" 
                            @change="updateSite"
                            @click:clear="filters.site = undefined; siteCmb = undefined;">
                        </v-combobox>
                    </v-col>
                </v-row>
                <v-alert v-if="datealert"
                    text
                    prominent
                    type="error"
                    >
                    La date de début doit être inférieure à la date de fin
                </v-alert>
            </v-card-text>
        </v-card>


        <v-data-table
            :headers="fields"
            :items="filteredHoraires"
            :items-per-page="10"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="elevation-1"
            :loading="loading"
            loading-text="Chargement..."
        >
        <template v-slot:item.date="{ item }">
            {{utils.toPrettyDate(item.date)}}
        </template>
        <template v-slot:item.fonction="{item}">{{fonctionsById[item.id_fonction].nom}}</template>      
        <template v-slot:item.site="{item}">{{sitesById[item.id_site].nom}}</template>  
        <template v-slot:item.sceances="{item}">
            <seances :item="item" />
        </template>
        <template v-slot:item.employe="{item}">
        <span
          v-if="item.type === 1"
        ><span v-if="employesById[item.id_employe]">{{employesById[item.id_employe].nom}} {{employesById[item.id_employe].prenom}}</span></span>
        <span v-else>
          <b>QSP</b>
        </span>
      </template>
        <template v-slot:item.remp="{item}"><v-btn @click="demandeRemplacement(item.id)" dense><v-icon>mdi-swap-horizontal</v-icon></v-btn></template>
        </v-data-table>
    </v-container>
</template>

<script>
import api from "@/api";
import utils from "@/utils";
import Seances from "@/components/Seances";
import moment from "moment";
import store from "@/store";

export default {
  data() {
    return {
      sites: [],
      horaires: [],
      perPage: 15,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      fields: [
        { value: "id", text: "Référence", sortable: true },
        { value: "date", text: "Date", sortable: true },
        { value: "site", text: "Site", sortable: false },
        { value: "employe", text: "Employé", sortable: false },
        { value: "fonction", text: "Fonction", sortable: false },
        { value: "sceances", text: "Séances", sortable: false },
        { value: "remarque", text: "Remarque", sortable: false },
      ],
      siteCmb: undefined,
      utils,
      filters: {
        begindate: null,
        enddate: null,
        site: undefined,
        date: null,
      },
      datealert: false,
      employes: [],
      sitesById: [],
      fonctionsById: [],
      employesById: [],
    };
  },
  components: { Seances },
  created() {
    this.loadData();
  },
  computed: {
    loading() {
      return store.state.loading;
    },
    momentFormattedBegin() {
        return this.filters.begindate ? this.utils.toPrettyDate(this.filters.begindate) : '';
    },
    momentFormattedEnd(){
        return this.filters.enddate ? this.utils.toPrettyDate(this.filters.enddate) : '';
    },
    filteredHoraires() {
      return this.horaires.filter((horaire) => {
        let ok = true;
        if (ok && this.filters.site !== undefined) {
          if (horaire.id_site !== this.filters.site) {
            ok = false;
          }
        }
        if (ok && this.filters.begindate !== null) {
          if (moment(horaire.date).isBefore(this.filters.begindate, "day")) {
            ok = false;
          }
        }
        if (ok && this.filters.enddate !== null) {
          if (moment(horaire.date).isAfter(this.filters.enddate, "day")) {
            ok = false;
          }
        }
        if (ok && !horaire.visible) {
          ok = false;
        }
        return ok;
      });
    },
  },
  methods: {
    async loadData(){
      this.$store.commit("setLoading", true);
      this.sites = (await api.getSites()).data.sites;
      for (let site of this.sites) {
        this.sitesById[site.id] = site;
      }
      this.employes = (await api.getEmployes()).data.employes;
      for (let employe of this.employes) {
        this.employesById[employe.id] = employe;
      }
      this.fonctions = (await api.getFonctions()).data.fonctions;
      for (let fonction of this.fonctions) {
        this.fonctionsById[fonction.id] = fonction;
      }
      this.horaires = (await api.getHorairesGeneral()).data.horaires;
      this.$store.commit("setLoading", false);
    },
    updateSite(){
        if (this.siteCmb) this.filters.site = this.siteCmb.id;
    },
    onDateChange() {
        this.$refs.menuEnd.save(this.filters.enddate);
        this.$refs.menuBegin.save(this.filters.begindate);
        if (this.filters.date) {
            this.filters.begindate = this.filters.date;
            this.filters.enddate = this.filters.date;
        }
        this.datealert =
            this.filters.begindate !== null &&
            this.filters.enddate !== null &&
        moment(this.filters.begindate).isAfter(this.filters.enddate, "day");
    },
    onClearDate() {
      this.filters.begindate = null;
      this.filters.enddate = null;
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.sib) return "table-secondary";
    },
    generatePDF() {
      api.pdf(`horairesgeneral`, { filters: this.filters, limit: true }, `horaire-general`);
    },
  },
};
</script>